import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import Landing from './pages/landing/Landing';
import Login from './pages/Login';
import Projects from './pages/Projects';
import ProjectCanvas from './pages/ProjectCanvas';
import Vision from './pages/Vision';
import Entertainment from './pages/Entertainment';
import Finances from './pages/Finances';
import JarvisInterface from './components/JarvisInterface';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Legatia from './pages/Legatia';
import Home from './pages/Home';
import './styles/custom-scroll.css';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        
        {/* Protected app routes */}
        <Route path="/app/*" element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="home" element={<Home />} />
                <Route path="projects" element={<Projects />} />
                <Route path="legatia" element={<Legatia />} />
                <Route path="finances" element={<Finances />} />
                <Route path="vision" element={<Vision />} />
                <Route path="entertainment" element={<Entertainment />} />
                <Route path="chat" element={<JarvisInterface />} />
                <Route path="projects/:projectId/canvas" element={<ProjectCanvas />} />
                <Route path="*" element={<Navigate to="/app/home" />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default App;